<template>
  <div>
    <div v-for="app in appsListItems" class="mb-5">
      <v-layout row wrap align-center justify-space-between>
        <v-spacer />
        <v-flex xs2 sm2 md2>
          <center>
            <v-img width="57" :src="assetRoot + app.icon" />
          </center>
        </v-flex>
        <!-- <v-spacer /> -->
        <v-flex xs5 sm5 md5 class="my-2">
          <span class="app-title ml-2">{{app.title}}</span>
        </v-flex>
        <v-flex xs3 sm3 md3 class="my-2">
          <v-btn block class="rounded-button" color="#2c7fff" @click="openStore(app)">
            <template v-slot:default>
              <span class="get-button">GET</span>
            </template>
          </v-btn>
        </v-flex>
        <v-spacer />
      </v-layout>
      <v-layout class="" column>
        <v-flex v-for="listitem in app.texts">
          <v-layout row wrap align-center>
            <v-spacer />
            <v-flex xs1 sm1 md1>
              <center>
                <v-img contain width="8" :src="assetRoot + 'oval-copy-3.png'" />
              </center>
            </v-flex>
            <v-flex xs9 sm9 md9>
              <span class="app-description">{{ listitem }}</span>
            </v-flex>
            <v-spacer />
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      'store_mode': {
        type: String,
        default: 'organic'
      }
    },
    data () {
      return {
        appsListItems: [
          {
            key: 'learning_guitar', title: 'Guitar', icon: 'icon-guitar.png',
            texts: ['Learn and play guitar with ultra realistic sound', 'Thousands of songs with lessons updated regularly', 'Play any style: rock, jazz, pop, blues...']
          },
          {
            key: 'learning_piano', title: 'Piano', icon: 'icon-piano.png',
            texts: ['Choose your favorite keyboard', 'Thousands of songs with lessons updated regularly', 'Professional metronome included']
          },
          {
            key: 'learning_drums', title: 'Drums', icon: 'icon-drums.png',
            texts: ['Learn and play drums with ultra realistic sound', 'Thousands of songs with lessons updated regularly', 'Play any style: rock, jazz, metal, dance...']
          },
          {
            key: 'learning_sampler', title: 'Beat Maker Pro', icon: 'icon-bmp.png',
            texts: ['Create beats and make music', 'Thousands of sounds and tutorial updated regularly', 'All genres: EDM, pop, funk...']
          },
        ]
      }
    },
    methods: {
      openStore (app) {
        this.sendEvent('clicked_button', this.store_mode + '_download_app_' + app.key)

        let url = ''
        if (this.store_mode === 'organic') {
          url = this.organicStoreAttributionUrls[app.key]
        } else {
          url = this.storeAttributionUrls[app.key]
        }
        if (url === '') { return }

        var win = window.open(url)
        win.focus()
      },
      sendEvent (type, value) {
        let payload = {
          env: this.env,
          headers: { appKey: this.appKey, offer: this.offer, version: this.version },
          body: {
            session_id: this.sessionId,
            layout_id: this.layoutId,
            user_instance_id: this.userInstanceId,
            type: type,
            value: value,
          }
        }
        this.$store.dispatch('EVENT_SEND', payload)
      }
    },
    computed: {
      ...mapGetters([
        'env',

        'assetRoot',
        'attributionPlatform',
        'storeAttributionUrls',
        'organicStoreAttributionUrls',

        'appKey',
        'offer',
        'version',
        'deviceType',
        'sessionId',
        'layoutId',
        'userInstanceId',
      ])
    }
  }
</script>

<style scoped>
.app-title {
  font-family: CenturyGothic;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.rounded-button {
  width: 93px;
  height: 40px;
  border-radius: 36px;
  background-color: #2c7fff;
}

.get-button {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 1.11px;
  color: #ffffff;
}

.app-description {
  font-family: CenturyGothic;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
</style>
